<template>
  <section class="mafco-footer">
    <p>© Copyright 2021<span style="margin: 0 20px">|</span>沪ICP备100000-0<span style="margin: 0 20px">|</span>MAFCO All Rights Reserved</p>
  </section>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    language () {
      return this.$store.state.language || '1'
    }
  }
}
</script>

<style lang="scss" scoped>
.mafco-footer {
  // background: #333;
  background-color: #116534;
  height: 80px;
  text-align: center;
  line-height: 80px;
  color: #fff;
  padding-top: 20px;
  box-sizing: content-box;
}
</style>
